module.exports = __webpack_public_path__ + "media/win.11c7dc2b.mp3";